import { motion } from "framer-motion";
import type { GalleryCategory } from "./categories";

type Props = {
  categories: GalleryCategory[];
  activeId: string;
  onSelect: (id: string) => void;
};

export function CategoryTabs({ categories, activeId, onSelect }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Project categories"
      className="flex flex-wrap items-center justify-center gap-2 sm:gap-3"
    >
      {categories.map((c) => {
        const active = c.id === activeId;
        return (
          <button
            key={c.id}
            role="tab"
            aria-selected={active}
            onClick={() => onSelect(c.id)}
            className={`relative rounded-full px-5 py-2.5 text-sm font-semibold uppercase tracking-wider transition-colors ${
              active ? "text-white" : "text-white/70 hover:text-white"
            }`}
          >
            {active && (
              <motion.span
                layoutId="gallery-tab-pill"
                className="absolute inset-0 rounded-full bg-orange shadow-lg shadow-orange/30"
                transition={{ type: "spring", stiffness: 380, damping: 32 }}
              />
            )}
            <span className="relative z-10">{c.label}</span>
          </button>
        );
      })}
    </div>
  );
}
